import { modules } from "@core/utils/modules.js";

export default [
    {
        path: "payroll",
        name: "rrhh-payroll",
        redirect: () => {
            try {
                const userData = JSON.parse(localStorage.getItem("userData"));
                let userSections = [];
                if (userData && Array.isArray(userData.arr_sections)) {
                    userSections = userData.arr_sections.map(s => s.section_id);
                }
                const payrollTabs = [
                    { name: "rrhh-payroll-discounts", section: 45 },
                    { name: "rrhh-payroll-attendance", section: 46 },
                    { name: "rrhh-payroll-payments", section: 47 },
                    { name: "rrhh-payroll-salary-advance", section: 48 },
                    { name: "rrhh-payroll-vacations", section: 49 },
                    { name: "rrhh-payroll-gratifications", section: 50 },
                    { name: "rrhh-payroll-cts", section: 51 },
                    { name: "rrhh-payroll-bonos", section: 52 },
                    { name: "rrhh-payroll-dias-libres", section: 49 },
                    { name: "rrhh-payroll-periods", section: 53 },
                    { name: "rrhh-payroll-liquidaciones", section: 70 },
                ];
                const accessible = payrollTabs.find(tab => userSections.includes(tab.section));
                return accessible ? { name: accessible.name } : { name: "rrhh-payroll-discounts" };
            } catch (e) {
                return { name: "rrhh-payroll-discounts" };
            }
        },
        component: () => import("@/views/rrhh/views/payroll/Payroll.vue"),
        meta: {
            module: modules.RRHH,
            section: 14,
            pageTitle: "Payroll",
            breadcrumb: [
                {
                    text: "Pending",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "Discounts",
                    name: "rrhh-payroll-discounts",
                },
                {
                    title: "Attendance",
                    name: "rrhh-payroll-attendance",
                },
                {
                    title: "Payments",
                    name: "rrhh-payroll-payments",
                },
                {
                    title: "Adelanto de Sueldo",
                    name: "rrhh-payroll-salary-advance",
                },
                {
                    title: "Vacaciones",
                    name: "rrhh-payroll-vacations",
                },
                {
                    title: "Gratificaciones",
                    name: "rrhh-payroll-gratifications",
                },
                {
                    title: "CTS",
                    name: "rrhh-payroll-cts",
                },
                {
                    title: "Bonos",
                    name: "rrhh-payroll-bonos",
                },
                {
                    title: "Días Libres",
                    name: "rrhh-payroll-dias-libres",
                },
                {
                    title: "Periodos",
                    name: "rrhh-payroll-periods",
                }
            ],
        },
        children: [
            {
                path: "discounts",
                name: "rrhh-payroll-discounts",
                component: () =>
                    import("@/views/commons/discounts/components/DiscountComponent.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 45,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Discounts",
                            active: false,
                        },
                    ],
                    tabs: [
                        {
                            title: "Pending",
                            name: "rrhh-payroll-discounts-pending",
                        },
                        {
                            title: "Approved",
                            name: "rrhh-payroll-discounts-approved",
                        },
                        {
                            title: "Discounted",
                            name: "rrhh-payroll-discounts-discounted",
                        },
                        {
                            title: "Anulled",
                            name: "rrhh-payroll-discounts-anulled",
                        },
                    ],
                },
            },
            {
                path: "attendance",
                name: "rrhh-payroll-attendance",
                redirect: { name: "rrhh-payroll-attendance-administrative" },
                component: () =>
                    import("@/views/rrhh/views/payroll/components/AttendanceComponent.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 46,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Operations",
                            active: true,
                        },
                    ],
                    tab: 1,
                    tabs: [
                        {
                            title: "Administrative",
                            name: "rrhh-payroll-attendance-administrative",
                        },
                        {
                            title: "Operations",
                            name: "rrhh-payroll-attendance-operations",
                        },
                        {
                            title: "Justifications",
                            name: "rrhh-payroll-attendance-justifications",
                        },
                    ],
                },
                children: [
                    {
                        path: "administrative",
                        name: "rrhh-payroll-attendance-administrative",
                        component: () =>
                            import("@/views/commons/employee_attendance/AttendanceReportTable.vue"),
                        meta: {
                            module: modules.RRHH,
                            section: 46,
                            tab: "pending",
                            pageTitle: "Payroll",
                            breadcrumb: [
                                {
                                    text: "Attendance",
                                    active: false,
                                },
                                {
                                    text: "Administrative",
                                    active: true,
                                },
                            ],
                        },
                    },
                    {
                        path: "operations",
                        name: "rrhh-payroll-attendance-operations",
                        component: () =>
                            import("@/views/monitoring/views/reports/components/ReportsTab.vue"),
                        meta: {
                            module: modules.RRHH,
                            section: 46,
                            tab: 1,
                            pageTitle: "Payroll",
                            breadcrumb: [
                                {
                                    text: "Attendance",
                                    active: false,
                                },
                                {
                                    text: "Operations",
                                    active: true,
                                },
                            ],
                        },
                    },
                    {
                        path: "justifications",
                        name: "rrhh-payroll-attendance-justifications",
                        redirect: { name: "rrhh-payroll-attendance-justifications-pending" },
                        component: () =>
                            import("@/views/commons/employee_attendance/justifications/AttendanceJustificationMain.vue"),
                        meta: {
                            module: modules.RRHH,
                            section: 46,
                            tab: 1,
                            pageTitle: "Payroll",
                            breadcrumb: [
                                {
                                    text: "Attendance",
                                    active: false,
                                },
                                {
                                    text: "Justifications",
                                    active: true,
                                },
                            ],
                            tabs: [
                                {
                                    title: "Pending",
                                    name: "rrhh-payroll-attendance-justifications-pending",
                                },
                                {
                                    title: "Completed",
                                    name: "rrhh-payroll-attendance-justifications-completed",
                                },
                            ],
                        },
                        children: [
                            {
                                path: "pending",
                                name: "rrhh-payroll-attendance-justifications-pending",
                                component: () =>
                                    import(
                                  /* webpackChunkName: "RRHHAttendanceJustificationsPending" */ "@/views/commons/employee_attendance/justifications/tabs/AttendanceJustifications.vue"
                                    ),
                                meta: {
                                    module: modules.RRHH,
                                    section: 46,
                                    pageTitle: "Justifications",
                                    breadcrumb: [
                                        {
                                            text: "Pending",
                                            active: true
                                        },
                                    ],
                                    tab: 1,
                                },
                            },
                            {
                                path: "completed",
                                name: "rrhh-payroll-attendance-justifications-completed",
                                component: () =>
                                    import(
                                  /* webpackChunkName: "RRHHAttendanceJustificationsCompleted" */ "@/views/commons/employee_attendance/justifications/tabs/AttendanceJustifications.vue"
                                    ),
                                meta: {
                                    module: modules.RRHH,
                                    section: 46,
                                    pageTitle: "Justifications",
                                    breadcrumb: [
                                        {
                                            text: "Completed",
                                            active: true
                                        },
                                    ],
                                    tab: 2,
                                },
                            },
                        ]
                    },
                ]
            },
            {
                path: "payments",
                name: "rrhh-payroll-payments",
                redirect: { name: "rrhh-payroll-payments-administrative" },
                component: () =>
                    import("@/views/rrhh/views/payroll/components/AttendanceComponent.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 47,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Operations",
                            active: true,
                        },
                    ],
                    tab: 1,
                    tabs: [
                        {
                            title: "Administrative",
                            name: "rrhh-payroll-payments-administrative",
                        },
                        {
                            title: "Operations",
                            name: "rrhh-payroll-payments-operations",
                        },
                    ],
                },
                children: [
                    {
                        path: "administrative",
                        name: "rrhh-payroll-payments-administrative",
                        component: () =>
                            import("@/views/rrhh/views/payroll/components/AdministrativePayroll.vue"),
                        meta: {
                            module: modules.RRHH,
                            section: 47,
                            tab: "pending",
                            pageTitle: "Payroll",
                            breadcrumb: [
                                {
                                    text: "Payments",
                                    active: false,
                                },
                                {
                                    text: "Administrative",
                                    active: true,
                                },
                            ],
                        },
                    },
                    {
                        path: "operations",
                        name: "rrhh-payroll-payments-operations",
                        component: () =>
                            import("@/views/rrhh/views/payroll/components/OperationsPayroll.vue"),
                        meta: {
                            module: modules.RRHH,
                            section: 47,
                            tab: 1,
                            pageTitle: "Payroll",
                            breadcrumb: [
                                {
                                    text: "Payments",
                                    active: false,
                                },
                                {
                                    text: "Operations",
                                    active: true,
                                },
                            ],
                        },
                    },
                ]
            },
            {
                path: "salary-advance",
                name: "rrhh-payroll-salary-advance",
                component: () =>
                    import("@/views/rrhh/views/payroll/components/adelanto-sueldo/AdelantoSueldo.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 48,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Adelanto de Sueldo",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "vacations",
                name: "rrhh-payroll-vacations",
                component: () =>
                    import("@/views/rrhh/views/payroll/components/vacaciones/Vacaciones.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 49,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Vacaciones",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "gratifications",
                name: "rrhh-payroll-gratifications",
                component: () =>
                    import("@/views/rrhh/views/payroll/components/gratificaciones/Gratificaciones.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 50,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Gratificaciones",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "cts",
                name: "rrhh-payroll-cts",
                component: () =>
                    import("@/views/rrhh/views/payroll/components/cts/Cts.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 51,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "CTS",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "bonos",
                name: "rrhh-payroll-bonos",
                component: () =>
                    import("@/views/rrhh/views/payroll/components/bonos/Bonos.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 52,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Bonos",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "dias-libres",
                name: "rrhh-payroll-dias-libres",
                component: () =>
                    import("@/views/rrhh/views/payroll/components/dias-libres/DiasLibres.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 49,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Días Libres",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "periods",
                name: "rrhh-payroll-periods",
                component: () =>
                    import("@/views/rrhh/views/payroll/components/payroll-periods/PayrollPeriods.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 53,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Periodos",
                            active: true,
                        },
                    ],
                },
            },
        ],
    },
];